import { DocxState, THandleState } from "../interfaces";
import docxPageBuilder from "./docxPageBuilder";

import { shadow_thumbnail_style, shadow_sheet_mainview_body_style } from "../styles";

import JSZip from "jszip";
import * as XLSX from "xlsx";
const PDFJS = window.pdfjsLib;

//This is critical for the PDFJS module
PDFJS.GlobalWorkerOptions.workerSrc = "https://cdn.jsdelivr.net/npm/pdfjs-dist@3.4.120/build/pdf.worker.min.js"; //please make sure to always matching version with pdfjs-dist version

const TWIP: number = 566.9291338583; //This the unit used by docx to measure width , height and margin -> 1cm = 566.9291338583 twentieth of point (twip)

const alpha = Array.from(Array(26)).map((e, i) => i + 65);
const alphabet = alpha.map((x) => String.fromCharCode(x));

export const processImages = async (name: string, data: Blob, handleSetState: THandleState, fileExtension: string) => {
  const imgUrl = URL.createObjectURL(data);
  handleSetState({
    imgSrc: imgUrl,
    fileName: name,
    loading: false,
    fileExtension: fileExtension,
  });
};
export const processCSVFiles = async (name: string, data: Blob, handleSetState: THandleState) => {
  const file_reader = new FileReader();

  file_reader.readAsText(data);

  file_reader.onload = () => {
    handleSetState({
      pagesNumber: 1,
      file: data,
      fileName: name,
      fileExtension: "csv",
      loading: false,
      loadingPopulatePage: true,
    });

    const res = file_reader.result as string;
    const csv_rows = res?.split("\n");

    const table = document.createElement("table");

    Promise.all(
      csv_rows.map((csv_row, idx) => {
        const row_el = document.createElement("tr");
        const row_cells = csv_row.split(";");

        row_cells.pop();

        row_cells.forEach((cell, cell_idx) => {
          const cell_el = document.createElement("td");
          cell_el.setAttribute(
            "style",
            "border : 1px solid lightgray ;width: fit-content;white-space: nowrap;height : 18px"
          );
          cell_el.innerHTML = cell;
          row_el.appendChild(cell_el);
        });

        table.appendChild(row_el);
      })
    ).then(() => {
      table.setAttribute("style", "border-collapse : collapse ;  width : 100%");
      const main_viewer = document.getElementById("main-viewer");
      if (main_viewer?.shadowRoot === null) {
        main_viewer?.attachShadow({ mode: "open" });
      }

      if (main_viewer !== null && main_viewer?.shadowRoot !== null) {
        main_viewer.shadowRoot.innerHTML = "";
        main_viewer.shadowRoot.appendChild(table);

        handleSetState({
          loadingPopulatePage: false,
        });
      }

      const thumbnailPage = document.getElementById("page-0");

      if (thumbnailPage !== null) {
        if (thumbnailPage !== null)
          thumbnailPage.setAttribute(
            "style",
            "height : 28% ; overflow : hidden ; scale : 0.8 ; transform-origin : top left"
          );

        if (thumbnailPage?.shadowRoot === null) {
          thumbnailPage?.attachShadow({ mode: "open" });
        }

        if (thumbnailPage !== null && thumbnailPage?.shadowRoot !== null) {
          thumbnailPage.shadowRoot.innerHTML = "";
          thumbnailPage.shadowRoot.appendChild(table.cloneNode(true));
        }
      }
    });
  };
};

export const processTXTFiles = async (name: string, data: Blob, handleSetState: THandleState) => {
  const file_reader = new FileReader();

  file_reader.readAsText(data);

  file_reader.onload = () => {
    handleSetState({
      pagesNumber: 1,
      file: data,
      fileName: name,
      fileExtension: "txt",
      loading: false,
      loadingPopulatePage: true,
    });

    const main_viewer = document.getElementById("main-viewer");
    const thumbnailPage = document.getElementById("page-0");
    if (main_viewer !== null) {
      main_viewer.innerHTML = file_reader.result as string;
      handleSetState({
        loadingPopulatePage: false,
      });
    }

    if (thumbnailPage !== null) {
      const txt_container = document.createElement("p");
      txt_container.innerHTML = file_reader.result as string;
      txt_container.setAttribute("style", " font-size : 6px");
      if (thumbnailPage !== null)
        thumbnailPage.setAttribute("style", "height : 28% ; overflow : hidden ; border : 1px solid lightgray");

      if (thumbnailPage?.shadowRoot === null) {
        thumbnailPage?.attachShadow({ mode: "open" });
      }

      if (thumbnailPage !== null && thumbnailPage?.shadowRoot !== null) {
        thumbnailPage.shadowRoot.innerHTML = "";
        thumbnailPage.shadowRoot.appendChild(txt_container);
      }
    }
  };
};

export const processXLSX = async (
  name: string,
  data: Blob,
  handleSetState: THandleState,
  mainScale: number,
  sheetHeaderInlineStyle: string
) => {
  const xlsx_result = XLSX.read(await data.arrayBuffer(), { type: "array", cellStyles: true });
  const sheets_number = xlsx_result.SheetNames.length;
  const download_url = URL.createObjectURL(data);

  handleSetState({
    pagesNumber: sheets_number,
    file: xlsx_result,
    fileName: name,
    fileExtension: "xlsx",
    download_url: download_url,
    loading: false,
    loadingPopulatePage: true,
  });

  //Give time for DOM to buid divs for the thumbnails
  setTimeout(() => {
    xlsx_result.SheetNames.forEach((sheet, idx) => {
      const html_data = XLSX.utils.sheet_to_html(xlsx_result.Sheets[sheet]);

      populateXLSPages(`page-${idx}`, { html_data: html_data, sheet_title: sheet }, 0.2, sheetHeaderInlineStyle);

      if (idx === 0)
        populateXLSPages(
          `main-viewer`,
          { html_data: html_data, sheet_title: sheet },
          mainScale,
          sheetHeaderInlineStyle
        );

      if (idx === xlsx_result.SheetNames.length - 1) handleSetState({ loadingPopulatePage: false });
    });
  }, 300);
};

export const processPDF = async (name: string, data: Blob, handleSetState: THandleState, mainScale: number) => {
  const pdf = await PDFJS.getDocument(URL.createObjectURL(data)).promise;
  const download_url = URL.createObjectURL(data);

  handleSetState({
    pagesNumber: pdf._pdfInfo.numPages,
    file: pdf,
    fileName: name,
    fileExtension: "pdf",
    download_url: download_url,
    loading: false,
    loadingPopulatePage: true,
  });

  //Give time for DOM to buid canvas for the thumbnails
  setTimeout(async () => {
    for (var i: number = 1; i <= pdf._pdfInfo.numPages; i++) {
      const page: typeof PDFJS.PDFPageProxy = await pdf.getPage(i);
      populatePDFPages(`page-${i - 1}`, page, 0.2);
      if (i === 1) populatePDFPages(`main-viewer`, page, mainScale);
      if (i === pdf._pdfInfo.numPages - 1 || (pdf._pdfInfo.numPages === 1 && i === 1))
        handleSetState({ loadingPopulatePage: false });
    }
  }, 600);
};

// export const parseDOCXMLFiles = async (
//   name: string,
//   data: Blob,
//   handleSetState: THandleState,
//   docxState: DocxState,
//   docxStateRef: React.MutableRefObject<DocxState>,
//   handleSetDOCXState: THandleState
// ) => {
//   const _jszip = new JSZip();
//   const _zipped = await _jszip.loadAsync(data).then((resp) => {
//     return resp;
//   });
//   //const ab = await _zipped.generateAsync( {type : 'blob'}) //This will generate a zip file with type blob from wich we need to extract word/docuemnt.xml

//   /* PARSE THE FILES */
//   let document_xml: any;
//   let document_xml_rel: any;
//   let media_files: any[] = [];

//   var xmlParser = new DOMParser();

//   Object.keys(_zipped.files).map(function (filename, idx) {
//     if (filename.includes("word/media/", 0)) {
//       _zipped.files[filename].async("blob").then(function (fileData) {
//         handleSetDOCXState({
//           media_files: [
//             ...docxState.media_files,
//             {
//               name: filename.replace("word/", ""),
//               content: fileData,
//             },
//           ],
//         });

//         media_files?.push({
//           name: filename.replace("word/", ""),
//           content: fileData,
//         });
//       });
//     }

//     _zipped.files[filename].async("string").then(function (fileData) {
//       if (filename === "word/_rels/document.xml.rels") {
//         var asXML = xmlParser.parseFromString(fileData, "text/xml");
//         document_xml_rel = asXML;
//         handleSetDOCXState({ document_xml_rel: asXML });
//       } else if (filename === "word/document.xml") {
//         var asXML = xmlParser.parseFromString(fileData, "text/xml");
//         document_xml = asXML;
//         handleSetDOCXState({ document_xml: asXML });
//       }
//     });
//   });

//   setTimeout(() => {
//     processDOCX(name, document_xml, docxState, docxStateRef, handleSetState, handleSetDOCXState);
//   }, 1500);
// };

export const parseDOCXMLFiles = async (
  name: string,
  data: Blob,
  handleSetState: THandleState,
  docxState: DocxState,
  docxStateRef: React.MutableRefObject<DocxState>,
  handleSetDOCXState: THandleState
) => {
  const _jszip = new JSZip();
  const _zipped = await _jszip.loadAsync(data);

  let document_xml: any;
  let document_xml_rel: any;
  let media_files: any[] = [];

  var xmlParser = new DOMParser();

  const asyncOperations = Object.keys(_zipped.files).map(async function (filename, idx) {
    if (filename.includes("word/media/", 0)) {
      const fileData = await _zipped.files[filename].async("blob");

      handleSetDOCXState({
        media_files: [
          ...docxStateRef.current.media_files,
          {
            name: filename.replace("word/", ""),
            content: fileData,
          },
        ],
      });

      media_files?.push({
        name: filename.replace("word/", ""),
        content: fileData,
      });
    }

    const fileData = await _zipped.files[filename].async("string");
    if (filename === "word/_rels/document.xml.rels") {
      var asXML = xmlParser.parseFromString(fileData, "text/xml");
      document_xml_rel = asXML;
      handleSetDOCXState({ document_xml_rel: asXML });
    } else if (filename === "word/document.xml") {
      var asXML = xmlParser.parseFromString(fileData, "text/xml");
      document_xml = asXML;
      handleSetDOCXState({ document_xml: asXML });
    }
  });

  await Promise.all(asyncOperations);

  processDOCX(name, document_xml, docxState, docxStateRef, handleSetState, handleSetDOCXState);
};

export const processDOCX = async (
  name: string,
  document_xml: any,
  docxState: DocxState,
  docxStateRef: React.MutableRefObject<DocxState>,
  handleSetState: THandleState,
  handleSetDOCXState: THandleState
) => {
  /* APLLY GENERAL STYLE TO docxState */
  const general_style_lines = await document_xml.getElementsByTagName("w:sectPr")[0];
  const general_style_margin_line = await general_style_lines.getElementsByTagName("w:pgMar")[0];
  const general_style_measure_line = await general_style_lines.getElementsByTagName("w:pgSz")[0];

  /*********************************/

  /* BUILD THE PAGES */
  let pageBreakers: any[] = [];
  const allLinesInDocument: HTMLCollection = document_xml.getElementsByTagName("w:body")[0].children;

  // allElements = allLinesInDocument

  Array.from(allLinesInDocument).forEach((line: any, idx) => {
    //Look for the pageBrakers
    const breaker = line.getElementsByTagName("w:lastRenderedPageBreak");
    // if (breaker.length > 0) pageBreakers.push(idx);

    if (idx === allLinesInDocument.length - 1) {
      /* AFTER SETTING THE STATE , THE DOM WILL PREPARE THE THUMBNAILS THAT WILL RECEIVE THE PAGES */
      handleSetState({
        fileExtension: "docx",
        fileName: name,
        pagesNumber: pageBreakers.length + 1,
        loading: false,
        loadingPopulatePage: true,
      });

      handleSetDOCXState({
        docWidth: general_style_measure_line.getAttribute("w:w") / TWIP,
        docHeight: general_style_measure_line.getAttribute("w:h") / TWIP,
        docMarginTop: general_style_margin_line.getAttribute("w:top") / TWIP,
        docMarginRight: general_style_margin_line.getAttribute("w:right") / TWIP,
        docMarginBottom: general_style_margin_line.getAttribute("w:bottom") / TWIP,
        docMarginLeft: general_style_margin_line.getAttribute("w:left") / TWIP,
        headerHeight: general_style_margin_line.getAttribute("w:header") / TWIP,
        fotterHeight: general_style_margin_line.getAttribute("w:footer") / TWIP,
        allElements: allLinesInDocument,
      });

      /**START THE PAGE BUILD BY DIVIDING THE ELEMENTS  */
      setTimeout(() => {
        docxPagePreBuilder(
          pageBreakers,
          allLinesInDocument,
          docxState,
          docxStateRef,
          handleSetState,
          handleSetDOCXState
        );
      }, 1000);
    }
  });
  /*********************************/
};

export const docxPagePreBuilder = async (
  pageBreakers: number[],
  allLinesInDocument: any,
  docxState: DocxState,
  docxStateRef: React.MutableRefObject<DocxState>,
  handleSetState: THandleState,
  handleSetDOCXState: THandleState
) => {
  handleSetState({
    loading: false,
    loadingPopulatePage: true,
  });

  if (pageBreakers.length > 1) {
    pageBreakers.map(async (breaker, breaker_idx) => {
      if (breaker_idx === 0) {
        //THIS IS THE FIRST PAGE
        let pageElements: Element[] = [];
        for (var i = 0; i < breaker; i++) {
          pageElements.push(allLinesInDocument[i]);
          if (i === breaker - 1) {
            populateDOCXPages(true, 0, pageElements, true, docxStateRef, handleSetState);
            handleSetDOCXState({
              pages: [...docxState.pages, { elements: pageElements, pageNumber: 0 }],
            });
          }
        }
      } else if (breaker_idx !== 0 && breaker_idx !== pageBreakers.length - 1) {
        //THIS IS NOT THE LAST PAGE

        let pageElements: Element[] = [];
        for (var j = breaker; j < pageBreakers[breaker_idx + 1]; j++) {
          pageElements.push(allLinesInDocument[j]);
          if (j === pageBreakers[breaker_idx + 1] - 1) {
            populateDOCXPages(true, breaker_idx, pageElements, false, docxStateRef, handleSetState);
            handleSetDOCXState({
              pages: [...docxState.pages, { elements: pageElements, pageNumber: breaker_idx }],
            });
          }
        }
      } else {
        //THIS IS THE LAST PAGE

        let pageElements: Element[] = [];
        for (var k = breaker; k < allLinesInDocument.length - 1; k++) {
          pageElements.push(allLinesInDocument[k]);
          if (k === allLinesInDocument.length - 1) {
            populateDOCXPages(true, breaker_idx, pageElements, false, docxStateRef, handleSetState);
            handleSetDOCXState({
              pages: [...docxState.pages, { elements: pageElements, pageNumber: breaker_idx }],
            });
          }
        }

        handleSetState({
          loadingPopulatePage: false,
        });
      }
    });
  } else if (pageBreakers.length === 1) {
    let pageOneElements: Element[] = [];
    let pageTwoElements: Element[] = [];

    for (var l = 0; l < pageBreakers[0]; l++) {
      pageOneElements.push(allLinesInDocument[l]);

      if (l === pageBreakers[0] - 1) {
        populateDOCXPages(true, 0, pageOneElements, true, docxStateRef, handleSetState);
        handleSetDOCXState({
          pages: [...docxState.pages, { elements: pageOneElements, pageNumber: 0 }],
        });
      }
    }

    for (var m = pageBreakers[0]; m < allLinesInDocument.length; m++) {
      pageTwoElements.push(allLinesInDocument[m]);

      if (m === allLinesInDocument.length - 1) {
        populateDOCXPages(true, 1, pageTwoElements, false, docxStateRef, handleSetState);
        handleSetDOCXState({
          pages: [...docxState.pages, { elements: pageTwoElements, pageNumber: 1 }],
        });
      }
    }

    handleSetState({
      loadingPopulatePage: false,
    });
  } else if (pageBreakers.length === 0) {
    populateDOCXPages(true, 0, allLinesInDocument, true, docxStateRef, handleSetState);
  }
};

export const populateDOCXPages = async (
  thumbnail: boolean,
  page_number: number,
  pageElements: any,
  main: boolean,
  docxStateRef: React.MutableRefObject<DocxState>,
  handleSetState: THandleState
) => {
  const page_style = `transform-origin: top left ;scale : ${
    (12 / 100) * 1.5 * 0.8
  };box-sizing : border-box ; padding :${docxStateRef?.current.docMarginTop}cm ;width :${
    docxStateRef?.current.docWidth
  }cm ; height :${docxStateRef?.current.docHeight}cm ; border : lightgray 1px solid ; margin: 0 auto;`;
  const thumb_page_style = ` height :${docxStateRef?.current.docHeight * 0.18 * 0.8}cm ; overflow : hidden `;
  const main_viewer_style = `display : flex ; flex-direction : column ;box-sizing : border-box ; padding :${docxStateRef?.current.docMarginTop}cm ;width :${docxStateRef?.current.docWidth}cm ; height :${docxStateRef?.current.docHeight}cm ;  margin: 0 auto;`;

  let page = await docxPageBuilder(
    pageElements,
    docxStateRef?.current.document_xml_rel,
    docxStateRef?.current.media_files
  );

  page.setAttribute("style", page_style);

  if (thumbnail) {
    const thumbnailPage: HTMLElement | null = document.getElementById(`page-${page_number}`);
    if (thumbnailPage !== null) thumbnailPage.setAttribute("style", thumb_page_style);

    if (thumbnailPage?.shadowRoot === null) {
      thumbnailPage?.attachShadow({ mode: "open" });
    }

    if (thumbnailPage !== null && thumbnailPage?.shadowRoot !== null) {
      thumbnailPage.shadowRoot.innerHTML = "";
      thumbnailPage.shadowRoot.appendChild(page);
    }
  }

  if (main) {
    var page_clone = page.cloneNode(true) as HTMLDivElement;
    page_clone.setAttribute("style", main_viewer_style);

    const main_viewer_dom: HTMLElement | null = document.getElementById("main-viewer");
    if (main_viewer_dom?.shadowRoot === null) {
      main_viewer_dom?.attachShadow({ mode: "open" });
    }

    if (main_viewer_dom !== null && main_viewer_dom?.shadowRoot !== null) {
      main_viewer_dom.shadowRoot.innerHTML = "";
      main_viewer_dom.shadowRoot.appendChild(page_clone);
      handleSetState({
        loadingPopulatePage: false,
      });
    }
  }
};

export const populateXLSPages = (
  divID: string,
  { html_data, sheet_title }: { html_data: string; sheet_title: string },
  scale: number,
  sheetHeaderInlineStyle: string
) => {
  const rowsNumber = html_data.match(/<tr>/g)?.length;
  const totalColumnsNumbering = html_data.match(/<td/g)?.length;
  let columnsNumber = 0;
  const columnsNumbering = document.createElement("tr");
  if (rowsNumber !== undefined && totalColumnsNumbering !== undefined) {
    columnsNumber = totalColumnsNumbering / rowsNumber;
    for (var j: number = 0; j <= columnsNumber; j++) {
      const li = document.createElement("th");
      if (j > 0 && j < 26) {
        li.innerHTML = alphabet[j - 1];
        columnsNumbering.appendChild(li);
      } else if (j > 0 && j < 52) {
        li.innerHTML = alphabet[0] + alphabet[j - 25];
        columnsNumbering.appendChild(li);
      }
    }
  }
  columnsNumbering.setAttribute("id", "columns");

  const header = document.createElement("span");
  header.innerHTML = `${sheetHeaderInlineStyle}${sheet_title}`;

  const DOM_el: HTMLElement | null = document.getElementById(divID);
  if (DOM_el?.shadowRoot === null) DOM_el?.attachShadow({ mode: "open" });

  const sheet_container = document.createElement("div");
  const sheet_body = document.createElement("div");
  if (divID === "main-viewer") {
    sheet_body.innerHTML = shadow_sheet_mainview_body_style + html_data;
    // sheet_body.prepend(rowsNumbering)
    sheet_body.prepend(columnsNumbering);
    sheet_container.appendChild(sheet_body);
    const all_rows = sheet_container.querySelectorAll("tr");
    Array.from(all_rows).forEach((row, idx) => {
      if (idx !== 0) {
        const numbering = document.createElement("th");
        numbering.innerHTML = idx.toString();
        row.prepend(numbering);
      } else {
        row.prepend(document.createElement("td"));
      }
    });
    const table = sheet_container.querySelector("table");
    const table_header = document.createElement("thead");
    table_header.appendChild(columnsNumbering);
    table?.prepend(table_header);
  } else {
    sheet_body.innerHTML = shadow_thumbnail_style + html_data;
    sheet_container.appendChild(sheet_body);
  }

  if (DOM_el !== null && DOM_el?.shadowRoot !== null) {
    DOM_el.shadowRoot.innerHTML = "";
    DOM_el.shadowRoot.appendChild(header);
    DOM_el.shadowRoot.appendChild(sheet_container);

    // handleSetState({
    //     loadingPopulatePage : false
    // })
  }
};

export const populatePDFPages = (canvasId: string, page: typeof PDFJS.PDFPageProxy, scale: number) => {
  var viewport = page.getViewport({ scale: scale });

  var canvas = document.getElementById(canvasId) as HTMLCanvasElement;

  if (!!canvas) {
    canvasId === "page-0" ? canvas.classList.add("current") : canvas.classList.remove("current");

    var context = canvas?.getContext("2d");

    canvas.height = viewport.height;
    canvas.width = viewport.width;

    if (context !== null) page.render({ canvasContext: context, viewport: viewport });
  }
};
